import { writable } from "svelte/store";
import { debounce } from "./util.js";

function createQuests() {
  let quests = [];
  // let _quests = _quests2;
  let ref;
  // const { subscribe, set, update } = writable(_quests);
  const { subscribe, set, update } = writable([], (set) => {
    ref = firebase.database().ref("edulearn/quests/");
    // console.log("Вызван set у Quests " + JSON.stringify(firebase.auth().currentUser, null, 2));
    ref.once("value", function (allQuestsSnap) {    
      console.log("ПОДПИСАЛИСЬ НА QUESTS");
      allQuestsSnap.forEach(snap => {
        let questKey = snap.key;
        let quest = snap.val();
        if (!quest.tasks) {
          quest.tasks = [];
        }
        if (!quest.tips) {
          quest.tips = [];
        }
        quests.push(quest);
      });  
      set(quests);
    });

    return () => {
      console.log("ОТПИСАЛИСЬ ОТ QUESTS");
      
      quests = [];
      ref && ref.off(); // {};//
    }
  });

  function addQuest(quest) {
    var newQuestRef = ref.push();
    var questId = newQuestRef.key;
    quest.id = questId;
    newQuestRef.set(quest);
    quests = [...quests, quest];
    set(quests);
  }

  function getNamebyId(id) {
    // console.log("qid" + id);
    // console.log("quests " + JSON.stringify(quests));
    let foundQuest = quests.find(q => q.id == id);
    return foundQuest ? foundQuest.name : "не найден"
  }

  // function getQuestbyId(id) {
  //   return quests.find(q => q.id == id);
  // }  

  return {
    subscribe: subscribe,
    set: set,
    addQuest,
    getNamebyId//,
    // getQuestbyId
  };
}

export const quests = createQuests();

function createQuest() {
  const emptyQuest = { tasks: [], tips: [], loading: true };
  let quest;
  let currentQuestId;
  let ref;
  let refAllQuests;
  // let loading = true;

  const { subscribe, set, update } = writable(emptyQuest, (set) => {
    console.log('ПОДПИСАЛИСЬ НА QUEST');
    set(emptyQuest);

    refAllQuests = firebase.database().ref("edulearn/quests/");
    refAllQuests.on("child_changed", function (snap) {
      let questKey = snap.key;
      quest = snap.val();
      console.log('child_changed: ' + currentQuestId);
      // console.log('val', JSON.stringify(snap, null, 2));

      if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);

      if (!quest) { // при первом заходе на страницу квест не выбран
        quest = emptyQuest;
      } else {
        if (!quest.tasks) {
          quest.tasks = [];
        } else {
          quest.tasks = Object.values(quest.tasks);
        }
        if (!quest.tips) {
          quest.tips = [];
        } else {
          quest.tips = Object.values(quest.tips);
        }
      }
      set(quest);
    });
    
    return () => {
      quest = emptyQuest;
      ref && ref.off(); 
      refAllQuests && refAllQuests.off();
      console.log('ОТПИСАЛИСЬ ОТ QUEST');
    }
  });

  function setQuestId(id, cb) {
    currentQuestId = id;
    ref && ref.off();
    ref = firebase.database().ref("edulearn/quests/" + currentQuestId);
    // console.log('setQuestId: start');
    ref.once("value", function (snap) {      
      // loading = false;
      let questKey = snap.key;
      quest = snap.val();
      console.log('setQuestId: ' + currentQuestId);
      
      if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);
      
      if (!quest) { // при первом заходе на страницу квест не выбран
        quest = emptyQuest;
      } else {
        if (!quest.tasks) {
          quest.tasks = [];
        } else {
          quest.tasks = Object.values(quest.tasks);
        }
        if (!quest.tips) {
          quest.tips = [];
        } else {
          quest.tips = Object.values(quest.tips);
        }
      }
      quest.loading = false;
      set(quest);
      cb && cb(quest);
    });
  }

  function addTask(task) {
    console.log('addTask', JSON.stringify(task));
    var newTaskRef = ref.child('tasks').push(); 
    var taskId = newTaskRef.key;
    task.id = taskId;
    task.processingcode = task.processingcode || null;    
    newTaskRef.set(task);
    return taskId;
  }  

  function updateTask(task) {
    // console.log('updateTask', JSON.stringify(task));
    task.processingcode = task.processingcode || null;
    ref && task && ref.child('tasks').child(task.id).set(task); 
  }

  function addTip(tip) {
    console.log('add tip', JSON.stringify(tip));
    var newTipRef = ref.child('tips').push(); 
    var tipId = newTipRef.key;
    tip.id = tipId;
    newTipRef.set(tip);
    return tipId;
  }    

  function updateTip(tip) {
    console.log('updateTip', JSON.stringify(tip));
    ref && tip && ref.child('tips').child(tip.id).set(tip); 
  }

  function setQuestStartTask(id) {
    ref.update({startTask: id});
  }

  function getTaskById(id) {

  }

  return {
    subscribe: subscribe,
    set: set,
    update: update,
    getQuestStartTask: () => quest.startTask,
    setQuestStartTask,
    addTask,
    // updateTask: debounce(updateTask, 3000),
    updateTask,
    addTip,
    updateTip: debounce(updateTip, 3000),    
    getTaskById,
    setQuestId,
    getQuestId: () => currentQuestId,
    getTasks: () => quest.tasks,
    getTips: () => quest.tips
  };
}

export const quest = createQuest();

// DERIVED
// export const quest = derived([currentQuestId, quests], ([$a, $b], set) => {
//   set(_quests.find((q) => {console.log("derived " + q.id); return q.id == $a}));
//   return () => {
// 		console.log("derived end");
// 	};
// });
